import { Ref } from "react";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { validateInitialDetailsFieldValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import { useMediaById } from "@coworker/app/src/components/RoomSettings/hooks/useMediaById";
import { useTranslation } from "@coworker/locales";
import { TitledTextWithMargins } from "../../../TitledText/TitledText";

export type MediaLocationCreatorFragmentConfigProps = {
  field: string;
  title: string;
};

type MediaLocationCreatorFragmentProps = {
  configProps: MediaLocationCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function MediaLocationCreatorFragment({
  configProps,
  commonProps,
}: MediaLocationCreatorFragmentProps) {
  const { field, title } = configProps;
  const { task, taskType } = commonProps;
  const mediaId = validateInitialDetailsFieldValue<string>(
    getByPath(task, field),
    field,
    taskType
  );
  const { data: mediaResponse, isLoading: isMediaLoading } = useMediaById(
    isLoading(mediaId) ? null : mediaId
  );
  const { t } = useTranslation();

  if (isLoading(mediaId) || isMediaLoading) {
    return <LoadingCreatorFragment />;
  }

  return (
    <TitledTextWithMargins
      title={t(title)}
      text={mediaResponse?.media?.name ?? ""}
    />
  );
}

export default MediaLocationCreatorFragment;
